import style from './listaVendaNacional.module.scss';
import { useState } from 'react';
import { IVendaNacional } from '../../../../../../../../../../../interfaces/IVendaNacional';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import ListaVendaNacionalItem from './listaVendaNacionalItem/listaVendaNacionalItem';

export interface IListaVendaNacionalProps {
  vendasNacionais: IVendaNacional[];
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  refetchLista: () => void;
  refetchDados: () => void;
}

function ListaVendaNacional({
  vendasNacionais,
  setBaseDeCalculo,
  setIsEdicao,
  refetchLista,
  refetchDados,
}: Readonly<IListaVendaNacionalProps>) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title} data-testid='titulo-ncm'>
            Venda no Território Nacional Entre Empresas Coligadas ou do Mesmo Grupo Econômico
          </div>
        </div>
        <div className={style.rightContainer}></div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          {vendasNacionais?.map((item, index) => (
            <ListaVendaNacionalItem
              vendaNacional={item}
              index={index}
              key={item.id}
              setBaseDeCalculo={setBaseDeCalculo}
              setIsEdicao={setIsEdicao}
              refetchLista={refetchLista}
              refetchDados={refetchDados}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default ListaVendaNacional;
